export const YANDEX_METRIKA_ID = 11881159;
